export interface DetectedReference {
  value: string
  source: 'subject'
}

// A claim reference is 3 alphanumeric characters + dot + 6 digits. This single
// shape covers every known format: MC1 (MUK.789043), aviation (A03.001315),
// Norcross (M21.028304) and numeric-prefixed (103.000334). See MSD-591.
//
// Lookbehind/lookahead instead of \b so underscore-adjacent references still
// match (\b fails because _ is a word character, e.g. ABC.123456_inbox).
const REFERENCE_PATTERN = /(?<![A-Za-z0-9])([A-Za-z0-9]{3}\.\d{6})(?![A-Za-z0-9])/g

const REPLY_PREFIX_PATTERN = /^(RE|FW|FWD)\s*:/i

export function isReplyOrForward(subject: string): boolean {
  return REPLY_PREFIX_PATTERN.test(subject)
}

/**
 * Extracts the first claim reference from the email subject.
 * Returns null if no reference is found.
 */
export function extractClaimReference(subject: string): DetectedReference | null {
  REFERENCE_PATTERN.lastIndex = 0
  const match = REFERENCE_PATTERN.exec(subject)
  if (match) {
    return { value: match[1].toUpperCase(), source: 'subject' }
  }
  return null
}
